import React from "react";
import styles from "./FlashAssistant.module.scss";

export default function SummaryCards({
  totalEnquiries = 0,
  topSource = "—",
  conversionRate = "—",
  applicationsSubmitted = 0,
}) {
  const cards = [
    { label: "Enquiries", value: String(totalEnquiries) },
    { label: "Top Source", value: topSource },
    { label: "Conversion", value: typeof conversionRate === "number" ? `${conversionRate}%` : conversionRate },
    { label: "Applications", value: String(applicationsSubmitted) },
  ];

  return (
    <div className={styles.summaryCards}>
      {cards.map(({ label, value }) => (
        <div key={label} className={styles.summaryCard}>
          <div className={styles.summaryCardLabel}>{label}</div>
          <div className={styles.summaryCardValue}>{value}</div>
        </div>
      ))}
    </div>
  );
}
